const setup = async() => {
  return new Promise<HTMLScriptElement>((resolve, reject) => {
    const script = document.createElement("script")
    script.type = "text/javascript"

    script.src = "https://player.vimeo.com/api/player.js"

    script.addEventListener("load", () => resolve(script), false)
    script.addEventListener("error", () => reject(script), false)
    document.body.appendChild(script)
  })
}

export default {setup}
